import { render, staticRenderFns } from "./ChatOverlay.vue?vue&type=template&id=ce6bd856&"
import script from "./ChatOverlay.vue?vue&type=script&lang=js&"
export * from "./ChatOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ChatOverlay.vue?vue&type=style&index=0&id=ce6bd856&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports